import { render, staticRenderFns } from "./LeaveForm.vue?vue&type=template&id=87d85842&"
import script from "./LeaveForm.vue?vue&type=script&lang=js&"
export * from "./LeaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports